export type Environment = ReturnType<typeof getEnvironment>
export function getEnvironment(): 'local' | 'development' | 'staging' | 'production' {
  if (!import.meta.env.PROD && import.meta.env.DEV) {
    return 'local'
  }

  const mode = import.meta.env.MODE
  if (mode === 'development' || mode === 'dev') {
    return 'development'
  }
  if (mode === 'staging') {
    return 'staging'
  }
  return 'production'
}
